<p>shopping-list-detail works!</p>
